import React from "react";
import { Box, Typography } from "@mui/material";
import ModuleIconBadge from "../ModuleIconBadge";

/**
 * A centred "nothing here yet" panel: the module's badge, a title, one line
 * of explanation and an optional action (a button, a link). Used where a
 * page has no data to show, so the page still says what belongs there.
 */
export default function EmptyState({ moduleKey, title, description, action }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1.25,
        py: 8,
        px: 3,
        border: "1px dashed",
        borderColor: "divider",
        borderRadius: 3,
        bgcolor: "action.hover",
      }}
    >
      {moduleKey && <ModuleIconBadge moduleKey={moduleKey} size="lg" />}
      <Typography variant="h6">{title}</Typography>
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 420 }}
        >
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Box>
  );
}
